export const GET_TESTIMONIALS = "GET_TESTIMONIALS";
export const FILTER_TESTIMONIALS = "FILTER_TESTIMONIALS";
export const ADD_TESTIMONIAL = "ADD_TESTIMONIAL";
export const EDIT_TESTIMONIAL = "EDIT_TESTIMONIAL";
export const GET_TESTIMONIAL = "GET_TESTIMONIAL";
export const RESET_TESTIMONIAL = "RESET_TESTIMONIAL";
export const TESTIMONIALS_ERROR = "TESTIMONIALS_ERROR";
